<template>
  <div>
    <el-dialog title="立即体验" class="tryNow" :visible.sync="visible" :show="show" @close="$emit('update:show', false)"
               :close-on-click-modal="false" :close-on-press-escape="false" width="68%">
      <!--:before-close="handleClose"-->
      <form method="post" id="userInfo" action="/">
        <el-row>
          <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14" class="text-center userInfo">
            <p>请留下您的联系方式，稍后我们会将体验方式发送至您的邮箱</p>
            <div class="demo-input-suffix">
              <label>姓名<em>*</em></label>
              <el-input placeholder=""
                        v-model="name"
                        name="name"
                        clearable>
              </el-input>
            </div>
            <div class="demo-input-suffix">
              <label>手机号码<em>*</em></label>
              <el-input placeholder=""
                        v-model="mobile"
                        name="mobile"
                        clearable>
              </el-input>
            </div>
            <div class="demo-input-suffix">
              <label>联系邮箱<em>*</em></label>
              <el-input placeholder=""
                        v-model="email"
                        type="email"
                        name="email"
                        clearable>
              </el-input>
            </div>
            <div class="demo-input-suffix">
              <label>公司名称<em>*</em></label>
              <el-input placeholder=""
                        v-model="company"
                        name="company"
                        clearable>
              </el-input>
            </div>
            <button class="button button-calm" @click="submit">提交</button>

          </el-col>
          <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
            <p style="font-size: 20px;color: #000;margin-bottom: 40px">或者微信加入客户群组体验交流</p>
            <img v-lazy="ercode_2" width="230px"/>
            <p style="font-size: 18px;color: #999;margin: 10px 0 30px">微信扫码，快速入群</p>
          </el-col>
        </el-row>
      </form>
    </el-dialog>
  </div>
</template>

<script>
import ElCol from 'element-ui/packages/col/src/col'
  import ElRow from 'element-ui/packages/row/src/row'
  import ercode_2 from "../assets/img/ercode_2.png"

  export default {
    name: 'CollectUserInfoDialog',
    components: {
      ElRow,
      ElCol
    },
    componentName: 'CollectUserInfoDialog',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      show () {
        this.visible = this.show;
      }
    },
    data() {
      return {
        visible: this.show,
        ercode_2: ercode_2,

        name: '',
        mobile: '',
        email: '',
        company: ''
      }
    },
    methods: {
      submit(event){
        var $this = this;

        var form = new FormData(document.getElementById('userInfo'));
        var req = new XMLHttpRequest();
        req.open('POST', '/', true);
        req.onload = function (event) {
          if (req.status == 200) {
            var rsp = JSON.parse(req.response);
            if (rsp.code == 200) {
              $this.$emit('update:show', false);
            } else {
              alert(rsp.msg);
            }
          } else {
            alert('提交失败, 请重试');
          }
        }
        req.send(form);
        event.preventDefault();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CollectUserInfoDialog.vue